var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex rounded-sm justify-content-center align-items-center"},[_c('div',{staticClass:"d-flex rounded-sm justify-content-center align-items-center",staticStyle:{"gap":"10px"},style:({
      backgroundColor: _vm.item.background,
      maxWidth: 'fit-content',
      padding: '4px 12px',
    })},[_c('div',{staticStyle:{"width":"6px","height":"6px","border-radius":"2px"},style:({ backgroundColor: _vm.item.color })}),_c('span',{style:({ color: _vm.item.color })},[_vm._v(_vm._s(_vm.item.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }